/**
 * Shared design tokens for the new visual facelift.
 * Originally created for Groups & Teams redesign, now shared across features.
 */
export const GT_COLORS = {
    // Primary
    primary: '#206FA5',
    primaryLight: '#EBF2FA',
    primaryHover: '#2B5A87',

    // Status - Green
    green: '#16A34A',
    greenLight: '#DCFCE7',
    greenBorder: '#BBF7D0',
    greenBg: '#F0FDF4',

    // Status - Amber
    amber: '#D97706',
    amberLight: '#FEF3C7',
    amberBorder: '#FDE68A',
    amberBg: '#FFFBEB',

    // Status - Red
    red: '#DC2626',
    redLight: '#FEE2E2',
    redBorder: '#FCA5A5',
    redBg: '#FEF2F2',

    // Text hierarchy
    textPrimary: '#1a1a2e',
    textSecondary: '#4A5568',
    textMuted: '#6B7A90',
    textFaint: '#9AA4B5',
    textDisabled: '#CBD5E1',

    // Backgrounds
    cardBg: '#ffffff',
    pageBg: '#F5F7FA',
    headerBg: '#FAFBFC',
    hoverBg: '#F8FAFC',

    // Borders
    border: '#E2E7ED',
    borderLight: '#F0F2F5',
    borderInput: '#DDE2E8',

    // Badges
    badgeTagBg: '#E8F4FD',
    badgeTagColor: '#206FA5',
    badgeGrayBg: '#F1F5F9',
    badgeGrayColor: '#64748B',
} as const;
